import React from "react";




const EnIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_52_292)">
        <mask
          id="mask0_52_292"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <path
            d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_52_292)">
          <path
            d="M-5.11652 -1.25048H25.1165V21.2257H-5.11652V-1.25048Z"
            fill="#00247D"
          />
        </g>
        <mask
          id="mask1_52_292"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <path
            d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_52_292)">
          <path
            d="M21.732 21.2256L9.99996 12.5004L-1.7404 21.2256H-5.11652V18.7068L6.61984 9.98762L-5.11652 1.25662V-1.25048H-1.7403L9.99996 7.47466L21.7322 -1.25048H25.1165V1.25624L13.3801 9.98762L25.1165 18.7062V21.2256H21.732Z"
            fill="white"
          />
        </g>
        <mask
          id="mask2_52_292"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <path
            d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_52_292)">
          <path
            d="M-2.86708 21.2256H-5.11652L8.88161 10.7562L-5.11652 0.424819V-1.25048L8.91694 9.11754L22.863 -1.25048H25.1165L11.0797 9.12044L25.1165 19.5503V21.2256L11.1698 10.793L-2.86708 21.2256Z"
            fill="#CF142B"
          />
        </g>
        <mask
          id="mask3_52_292"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <path
            d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask3_52_292)">
          <path
            d="M12.7441 21.9H7.25588V12.7317H-6.46478V7.2435H7.25588V-1.7H12.7441V7.2435H26.4648V12.7317H12.7441V21.9Z"
            fill="white"
          />
        </g>
        <mask
          id="mask4_52_292"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <path
            d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask4_52_292)">
          <path
            d="M11.6465 21.9H8.3535V11.6341H-6.46478V8.34116H8.3535V-1.7H11.6465V8.34116H26.4648V11.6341H11.6465V21.9Z"
            fill="#CF142B"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_52_292">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EnIcon;
